var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternalError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 167,
    viewBox: "0 0 124 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82726 111.543L34.4054 11.303C36.0218 6.32929 40.2319 2.64003 45.3747 1.69058L54.4024 0.0239258L101.641 106.202C107.216 118.733 98.7813 133.023 85.1168 134.199L23.9962 139.457C8.7457 140.769 -2.90386 126.101 1.82726 111.543Z",
    fill: "url(#paint0_linear_11498_97086)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82726 111.543L34.4054 11.303C36.0218 6.32929 40.2319 2.64003 45.3747 1.69058L54.4024 0.0239258L101.641 106.202C107.216 118.733 98.7813 133.023 85.1168 134.199L23.9962 139.457C8.7457 140.769 -2.90386 126.101 1.82726 111.543Z",
    fill: "url(#paint1_radial_11498_97086)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.173 106.974L42.3367 10.3655C46.0873 -1.64691 62.4271 -3.26193 68.4568 7.78378L120.422 102.978C127.316 115.607 118.986 131.16 104.654 132.422L37.4303 138.337C20.2492 139.849 7.03263 123.437 12.173 106.974Z",
    fill: "url(#paint2_linear_11498_97086)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1438 7.95454C62.2648 -2.81504 46.3335 -1.24038 42.6766 10.4717L12.513 107.08C7.44818 123.301 20.4704 139.472 37.3989 137.982L104.622 132.067C118.699 130.828 126.88 115.552 120.109 103.149L68.1438 7.95454ZM41.9963 10.2593C45.8406 -2.05344 62.589 -3.70884 68.7694 7.61302L120.734 102.807C127.751 115.662 119.273 131.493 104.685 132.777L37.4613 138.692C20.0275 140.226 6.61661 123.573 11.8326 106.867L41.9963 10.2593Z",
    fill: "url(#paint3_linear_11498_97086)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8411 11.3427C58.8243 7.63149 53.3367 8.17201 52.0828 12.2054L22.5678 107.145C19.1427 118.163 28.0188 129.122 39.5074 128.061L102.225 122.269C110.739 121.483 115.673 112.244 111.59 104.731L60.8411 11.3427ZM47.5926 10.8095C50.0809 2.80555 60.9705 1.7329 64.9726 9.09759L115.722 102.486C121.417 112.966 114.535 125.854 102.657 126.951L39.9398 132.744C25.1127 134.113 13.6572 119.969 18.0776 105.75L47.5926 10.8095Z",
    fill: "url(#paint4_linear_11498_97086)",
    stroke: "url(#paint5_linear_11498_97086)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M119.335 157.19C119.335 162.161 96.4245 166.163 68.2124 166.163C40.0003 166.163 17.0898 162.161 17.0898 157.19C17.0898 152.219 40.0003 148.216 68.2124 148.216C96.4245 148.216 119.335 152.219 119.335 157.19Z",
    fill: "url(#paint6_radial_11498_97086)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11498_97086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1763 35.4683L60.1628 33.5628L65.2388 92.0835L64.3027 92.3897C61.2339 93.3934 57.9897 91.4379 57.444 88.2557L49.6643 42.8872C49.1066 39.6348 51.0319 36.4691 54.1763 35.4683Z",
    fill: "url(#paint7_linear_11498_97086)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6638 33.4963L60.5173 32.7043L67.2218 92.1384L66.3015 92.4394C63.2274 93.4448 59.9786 91.4807 59.4405 88.2914L51.4744 41.0737C50.882 37.5627 53.1761 34.213 56.6638 33.4963Z",
    fill: "url(#paint8_linear_11498_97086)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2111 41.2125L63.2365 89.595C63.9824 93.5937 69.8885 92.977 69.7922 88.9105L68.6279 39.7072C68.5421 36.0799 65.7953 33.071 62.1908 32.6559C57.3291 32.0959 53.3137 36.4017 54.2111 41.2125Z",
    fill: "url(#paint9_linear_11498_97086)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8612 41.0913L63.8865 89.4737C64.4833 92.6727 69.2081 92.1793 69.1312 88.9261L67.9668 39.7228C67.8888 36.4254 65.3918 33.6902 62.1152 33.3128C57.6956 32.8038 54.0454 36.718 54.8612 41.0913ZM63.2365 89.595L54.2111 41.2125C53.3137 36.4017 57.3291 32.0959 62.1908 32.6559C65.7953 33.071 68.5421 36.0799 68.6279 39.7072L69.7922 88.9105C69.8885 92.977 63.9824 93.5937 63.2365 89.595Z",
    fill: "url(#paint10_linear_11498_97086)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_11498_97086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8449 104.198C72.0094 107.97 68.3085 111.128 64.5302 111.042C59.9649 110.939 56.7876 108.316 56.623 104.544C56.4585 100.772 59.2776 97.3508 63.48 97.1675C69.0223 96.9258 71.6804 100.426 71.8449 104.198Z",
    fill: "url(#paint11_linear_11498_97086)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8924 103.569C74.0694 107.629 70.3784 111.014 66.5992 110.91C62.033 110.783 58.8465 107.951 58.6694 103.892C58.4924 99.8326 61.3005 96.1606 65.503 95.9773C71.0453 95.7356 73.7153 99.5103 73.8924 103.569Z",
    fill: "url(#paint12_linear_11498_97086)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.887 103.228C74.064 107.287 71.5455 110.694 68.2617 110.837C64.9779 110.98 62.1724 107.806 61.9953 103.746C61.8183 99.6873 64.3368 96.2806 67.6206 96.1374C70.9044 95.9942 73.71 99.1687 73.887 103.228Z",
    fill: "url(#paint13_linear_11498_97086)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2329 110.176C71.0279 110.054 73.3935 107.089 73.2264 103.257C73.0592 99.4247 70.4445 96.6762 67.6494 96.7981C64.8544 96.92 62.4889 99.8857 62.656 103.718C62.8231 107.55 65.4379 110.298 68.2329 110.176ZM68.2617 110.837C71.5455 110.694 74.064 107.287 73.887 103.228C73.71 99.1687 70.9044 95.9942 67.6206 96.1374C64.3368 96.2806 61.8183 99.6873 61.9953 103.746C62.1724 107.806 64.9779 110.98 68.2617 110.837Z",
    fill: "url(#paint14_linear_11498_97086)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11498_97086",
    x: 45.5684,
    y: 29.5627,
    width: 23.6704,
    height: 67.0913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_11498_97086"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11498_97086",
    x: 52.6162,
    y: 93.1558,
    width: 23.2339,
    height: 21.8884,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_11498_97086"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11498_97086",
    x1: 43.9776,
    y1: 32.8915,
    x2: -55.9879,
    y2: 99.4556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314227,
    stopColor: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11498_97086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37 121.25) rotate(148.419) scale(34.922 25.687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573524,
    stopColor: "#70A1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11498_97086",
    x1: 126,
    y1: 129.5,
    x2: 27.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11498_97086",
    x1: 24.1987,
    y1: 49.9176,
    x2: 120.423,
    y2: 120.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11498_97086",
    x1: 32.7523,
    y1: 46.3537,
    x2: 100.466,
    y2: 110.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11498_97086",
    x1: 31.8123,
    y1: 50.2381,
    x2: 125.53,
    y2: 78.3984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69A1D5",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FAFCFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.32
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_11498_97086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.1686 157.08) scale(51.1393 8.94328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515067,
    stopColor: "#BDD0E3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746289,
    stopColor: "#B0D0F2",
    stopOpacity: 0.1656
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0D0F2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11498_97086",
    x1: 65.7608,
    y1: 73.2444,
    x2: 47.6196,
    y2: 75.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FBBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FBBD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11498_97086",
    x1: 53.3017,
    y1: 61.8184,
    x2: 58.8813,
    y2: 61.1461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AB7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#16CF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#00B07E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11498_97086",
    x1: 59.1989,
    y1: 39.9861,
    x2: 80.2165,
    y2: 81.2527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53DAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12B788"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11498_97086",
    x1: 52.3039,
    y1: 35.1644,
    x2: 84.1922,
    y2: 86.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491881,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11498_97086",
    x1: 55.4677,
    y1: 109.437,
    x2: 65.965,
    y2: 106.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EC5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11498_97086",
    x1: 59.7626,
    y1: 97.224,
    x2: 66.5947,
    y2: 110.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15D59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#039B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_11498_97086",
    x1: 67.6206,
    y1: 96.1374,
    x2: 68.2617,
    y2: 110.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CC89B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18B487"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_11498_97086",
    x1: 63.8805,
    y1: 97.8342,
    x2: 69.2931,
    y2: 105.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalError);
export default __webpack_public_path__ + "static/media/internal-error.f2a2b2326d8edb77524b4fa3f1b29dc6.svg";
export { ForwardRef as ReactComponent };